import { css } from 'styled-components';

const resetCSS = css`
    border: none;
    box-sizing: border-box;
    line-height: 1;
    margin: 0;
    outline: none;
    padding: 0;
`;

export const resetButtonCSS = css`
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font: inherit;
    outline: inherit;
    padding: 0;
`;

export default resetCSS;
